<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="col-3-sm" @click="filterConfig.show = 'open'" >
          <div class="filter-button button" v-bind:class="{selected: filterConfig.show == 'open'}">
            Open
          </div>
        </div>
        <div class="col-3-sm" @click="filterConfig.show = 'closed'" >
          <div class="filter-button button" v-bind:class="{selected: filterConfig.show == 'closed'}">
            Completed
          </div>
        </div>
        <div class="col-6-sm" @click="updateMasksTab()" >
          <div class="filter-button button" v-bind:class="{selected: filterConfig.show == 'masks'}">
            Masks
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="filterConfig.show == 'masks'">
      <div class="col-12">
        <div class="row res-container">
          <All-Pending-Masks-List
            :masks="allMasks"
            :updated="reservations.length"
          />
        </div>
      </div>
    </div>
    <div class="row" v-for="(res, i) in reservations" v-bind:key="res.updated.seconds" v-else>
      <transition-group enter-active-class="swing-in-top-fwd"
        leave-active-class="swing-out-bottom-bck">
        <div class="col-12" v-if="filter(res)" v-bind:key="res.updated.seconds">
          <div :id="res.uuid" class="col-12">
            <div class="row res-container">
              <div class="col-12">
                <div class="row res-header">
                  <div class="col-8-sm col-10">{{res.name}}</div>
                  <div class="col-4-sm col-2">
                    <div v-if="res.tab !='info'">
                      {{getTime(res.submitted)}}
                    </div>
                    <div v-else class="delete" @click="toggleTab('delete', i)">
                      <font-awesome-icon :icon="['fa', 'trash-alt']" size="xs" />
                    </div>
                  </div>
                  <div class="col-12 progress-container">
                    <div class="col-2-sm progress-element complete"
                    v-bind:class="{selected: res.tab == 'masks'}">
                      <div
                        class="progress-button"
                        @click="toggleTab('masks', i)"
                      >
                        <font-awesome-icon :icon="['fa', 'head-side-mask']"/>
                      </div>
                    </div>
                    <div class="col-2-sm progress-element complete"
                    v-bind:class="{selected: res.tab == 'info'}">
                      <div
                        class="progress-button"
                        @click="toggleTab('info', i)"
                      >
                        <font-awesome-icon :icon="['fa', 'info-circle']"/>
                      </div>
                    </div>
                    <div
                      class="col-2-sm progress-element"
                      @click="toggleTab('payment', i)"
                      v-bind:class="{
                        selected: res.tab == 'payment',
                        complete: res.payment,
                        incomplete: !res.payment
                        }">
                      <div class="progress-button">
                        <font-awesome-icon :icon="['fa', 'donate']" />
                      </div>
                    </div>
                    <div
                      class="col-2-sm progress-element"
                      @click="toggleTab('email', i)"
                      v-bind:class="{
                        selected: res.tab == 'email',
                        complete: res.emailCompleteSent,
                        incomplete: !res.emailCompleteSent}">
                      <div class="progress-button">
                        <font-awesome-icon :icon="['fa', 'paper-plane']" />
                      </div>
                    </div>
                    <div
                      class="col-2-sm progress-element"
                      @click="toggleTab('delivery', i)"
                      v-bind:class="{
                        selected: res.tab == 'delivery',
                        complete: res.delivery,
                        incomplete: !res.delivery
                        }">
                      <div class="progress-button">
                        <font-awesome-icon :icon="['fa', 'dolly']" />
                      </div>
                    </div>
                  </div>
                  <Header-MoreInfo
                    :res="res"
                    :i="i"
                    :toggleTab="toggleTab"
                    v-bind:key="res.tab"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {reservationsRef} from '../../firebase/firebaseConfig.js'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faHeadSideMask,
  faTrashAlt,
  faCheckCircle,
  faCircleNotch,
  faSignature,
  faChevronUp,
  faChevronDown,
  faDonate,
  faDolly,
  faPaperPlane,
  faInfoCircle} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHeadSideMask,
  faTrashAlt,
  faCheckCircle,
  faCircleNotch,
  faSignature,
  faChevronUp,
  faChevronDown,
  faDonate,
  faDolly,
  faPaperPlane,
  faInfoCircle)

import AllPendingMasksList from './components/AllPendingMasksList.vue'
import HeaderMoreInfo from './components/HeaderMoreInfo.vue'
export default {
  name: 'ReservationAdmin',
  components: {
    HeaderMoreInfo: HeaderMoreInfo,
    AllPendingMasksList: AllPendingMasksList
  },
  props: {
  },
  mounted() {
    let vm = this
    let sizeValues = {s:3, m:2, l:1}
    reservationsRef.orderBy('submitted').onSnapshot((resR) => {
      let allMasks = []
      resR.forEach((doc) => {
        let res = doc.data()
        res.uuid = doc.id
        if(res.submitted && !res.deleted) {

          // res.summary = {}
          // this.show[res.uuid] = false
          // vm.summary[res.uuid] = {}
          // sort/group the masks
          let sortedMasks = []
          // reser.masks.forEach(mask => {
          //   console.log('mask', mask)
          //   // if (m)
          // })
          res.masks.forEach((mask, i) => {
            let msk = {
              ...mask,
              resID: res.uuid,
              maskOrder: i,
              updated: res.updated
            }
            if(!msk.completed){
              allMasks.push(msk)
            }
          })
          sortedMasks = res.masks.sort(function(a,b) {
            // if these are the same, check with type
            // name first
            if (a.name == b.name) {
                if(sizeValues[a.size] == sizeValues[b.size]) {
                  if(a.type == b.type) {
                    return 0
                  } else {
                    return a.type < b.type ? -1 : 1
                  }
                } else {
                  return sizeValues[a.size] < sizeValues[b.size] ? -1 : 1
                }
            } else {
              return a.name < b.name ? -1 : 1
            }
          })
          res.masks = sortedMasks
          let resIndex = vm.reservations.findIndex(vmres => {
            return res.uuid == vmres.uuid
          })
          if (!res.delivery) {
            res.tab = 'masks'
          } else {
            res.tab = ''
          }
          if (resIndex >= 0) {
            vm.reservations[resIndex] = res
            vm.reservations.push([])
            vm.reservations.pop()
          } else {
            vm.reservations.push(res)
          }
        }
      })
      vm.allMasks = []

      vm.allMasks = allMasks.sort(function(a,b) {
        // if these are the same, check with type
        // name first
        if (a.name == b.name) {
            if(sizeValues[a.size] == sizeValues[b.size]) {
              if(a.type == b.type) {
                return 0
              } else {
                return a.type < b.type ? -1 : 1
              }
            } else {
              return sizeValues[a.size] < sizeValues[b.size] ? -1 : 1
            }
        } else {
          return a.name < b.name ? -1 : 1
        }
      })
    })
  },
  data: function (){
    return {
      filterConfig: {
        show: 'open'
      },
      reservations: [],
      show: {},
      allMasks: [],
      newPaymentAmount: null,
      newEventDate: this.today()
    }
  },
  methods: {
    updateMasksTab() {
      this.filterConfig.show = 'masks'
      // this.allMasks.push({})
      // this.allMasks.pop()
    },
    filter(res) {
      let status = true
      switch (this.filterConfig.show) {
        case 'open':
          status = this.isIncomplete(res)
          break;
        case 'closed':
          status = !this.isIncomplete(res)
          break;
        default:
      }
      return status
    },
    isIncomplete(res) {
      return !res.payment || !res.delivery || !this.masksComplete(res.masks)
    },
    today() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      if (month <= 9) {
        month = '0' + month;
      }
      let day = new Date().getDate()
      return [year, month, day].join('-')
    },
    toggleTab(tab, i) {
      let vm = this
      if (vm.reservations[i].tab == tab) {
        tab = ''
      }
      vm.reservations[i].tab = tab
      vm.reservations.push([])
      vm.reservations.pop()
    },
    getTime(time) {
      if (time && time.seconds) {
        return dayjs.unix(time.seconds).format('MM-DD-YYYY')
      } else {
        return null
      }
    },
    masksComplete(masks) {
      let complete = true
      masks.forEach(mask=>{
        if (!mask.completed) {
          complete = false
        }
      })
      return complete
    },
    sendCompleteEmail(res) {
      console.log('sending...')
      this.$store.commit('sendCompleteEmail', res)
    },
    formatEmailComplete(d) {
      if (d) {
        let day = new Date(d.seconds * 1000).toISOString().slice(5,10)
        let time = new Date(d.seconds * 1000).toLocaleTimeString().slice(0,5) + ' ' + new Date(d.seconds * 1000).toLocaleTimeString().slice(9,11)
        return day + ' / ' + time
      }
    },
    saveDelivery(method, id) {
      let vm = this

      let path = {
        delivery: {
          date: vm.newEventDate,
          method: method
        },
        updated: new Date(),
      }
      vm.reservations = []

      reservationsRef.doc(id).update(path).then(function() {
        setTimeout(function(){
          let elmnt = document.getElementById(id)
          elmnt.scrollIntoView();
        }, 1000);

      }).catch(function(error) {
        console.log('error', error)
      })
    },
    savePayment(method, id) {
      let vm = this

      let path = {
        payment: {
          amount: vm.newPaymentAmount,
          date: vm.newEventDate,
          method: method
        },
        updated: new Date(),
      }
      vm.reservations = []

      reservationsRef.doc(id).update(path).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.res-container {
  background: $oroGold;
  text-align: left;
  color: $oroGray;
  border-radius: 5px;
}
.filter-button {
  color: $oroGold;
  &.selected {
    font-weight: bold;

    &:after{
      content: " ";
      border-bottom: 2px solid $oroGold;
      border-radius: 5px;
      display: flex;
      margin: 0 auto;
      width: 50%;
    }
  }
}

.delete {
  background: #772e25;
  text-align: center;
  border-radius: 4px;
  border: 1px solid black;
  color: $oroGold;
  width: 50%;
  float: right;
  height: 25px;
  padding: 0;
  line-height: 1.2;
}
</style>
